import IndicatorForm from './StatusIndicatorForm';
import CrudPage from '@modules/cruds/CrudPage';
import { defaultConfigComponent } from '../StatusIndicators';
import * as yup from 'yup'; // for everything

const IndicatorSchema = yup.object().shape({
  name: yup.string().required().label('Name'),
  readingTypeId: yup.mixed().test('readingTypeId', 'Reading type not defined', function test() {
    const objectToValidate = this.parent;
    if (objectToValidate.update.live && !objectToValidate.update.anyReading && !objectToValidate.readingTypeId) {
      return this.createError({
        path: 'readingTypeId',
        type: 'required',
        params: { label: 'Reading Type' },
      });
    }
    return true;
  }),
  update: yup.object().shape({
    live: yup.bool(),
    manual: yup.bool(),
  }),
  type: yup.string(),
  possibleValues: yup.array().when('type', {
    is: 'list',
    then: yup.array().min(1, 'List indicators requires at least one possible state.'),
  }),
});

const IndicatorPage = props => {
  return (
    <CrudPage
      {...props}
      configComponent={defaultConfigComponent}
      form={IndicatorForm}
      validationSchema={IndicatorSchema}
      defaultValues={{
        type: 'list',
        possibleValues: ['Unknown'],
        newIconRule: {
          rule: { operation: undefined, operand: undefined },
          icon: { color: '#9e9e9e', name: null, type: 'svg' },
        },
        update: {
          manual: true,
          live: false,
          anyReading: false,
        },
        readingTypeId: null,
        display: 'icon',
        allowEmptyValue: false,
      }}
      essentialValues={new Set(['type', 'possibleValues', 'minValue', 'maxValue', 'update', 'display'])}
      warningToDelete={[
        'Doing so will affect event generation rules, event types workflows, and item status templates.',
        ' ',
        <b>This action cannot be undone.</b>,
      ]}
    />
  );
};

export default IndicatorPage;
